import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../../context/auth";
import axios from "axios";
import { ImpSectorInmueblesUrbanos } from "./modalImprimirContribuyentePor SectorCatastral";
import TablaInmueble from "./tablaInmuebles";
import TablaEstadoCuentaInmueble from "./tablaEstadoCuenta";
import TablaValorInmueble from "./tablaValorInmueble";
import { ModalConfiguracionInmuebles } from "./modalConfigInmueble";
import TablaUsuarioInmueble from "./tablaUsuariosInmuebles";
import { Toasts } from "../../toasts";
import Menu from "../../comun/Menu/Menu";
import Item from "../../comun/Menu/Item";
import imgPresupuesto from "../../../imagenes/fd_ingenieria.png";
import DasboardInmueble from "./tablaInmuebles";
function MenuPrincipalInmueble(props) {
  const { user } = useContext(AuthContext);
  const [show, setShow] = useState(false);
  const [titulo1, setTitulo1] = useState();
  const [titulo2, setTitulo2] = useState();
  const [tipoRep, setTipoRep] = useState();
  const [usuario, setUsuario] = useState("");
  const [activate, setActivate] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar, setMostrar] = useState(false);
  const [nomOrg, setNomOrg] = useState("");
  const [presu, setPresu] = useState();
  const [totalpresu, setTotalpresu] = useState(0.0);
  const [presupuesto, setPresupuesto] = useState(0.0);
  const [totalrc, setTotalrc] = useState(0.0);
  const [totalavi, setTotalavi] = useState(0.0);
  const [totalmenos, setTotalmenos] = useState(0.0);
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema"),
  );
  const [idefiscal] = useState(localStorage.getItem("idefiscal"));
  const [aniofiscal] = useState(localStorage.getItem("efiscalanio"));
  const [anioActu] = useState(localStorage.getItem("anioactu"));
  const [tabla, setTabla] = useState(0);
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const [configuracion, setConfiguracion] = useState();

  const accusrepsectcat = JSON.parse(localStorage.getItem("accusrepsectcat"));
  const accusrepmontaval = JSON.parse(localStorage.getItem("accusrepmontaval"));
  const accusrepmontdeud = JSON.parse(localStorage.getItem("accusrepmontdeud"));
  const accusreptipconstruc = JSON.parse(
    localStorage.getItem("accusreptipconstruc"),
  );
  const accusrepvalorconstruc = JSON.parse(
    localStorage.getItem("accusrepvalorconstruc"),
  );

  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");

  let el;
  function menuclick() {
    if ((el = document.getElementById("wrapper"))) {
      el.classList.toggle("toggled");
    }
  }

  const configInmueble = () => {
    let endpoint = `${op.conexion}/api/inmueble/configinmueble`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            setConfiguracion(response.data);
          }
        }
      })
      .catch((error) => {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  useEffect(() => {
    configInmueble();

    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);

    if (obj != null) {
      setUsuario(obj.login);
      setNomOrg(obj.nombreorg);
    } else {
      setUsuario("");
      setNomOrg("");
    }
  }, []);
  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };

  const actualizacionItem = {
    title: "Actualización",
    icon: "fas fa-pen-alt me-2",
    drop: [
      {
         title: "Registro Contribuyente Inmueble",
         itemClickValue: 1,
         icon: "fas fa-user-plus",
      },
      {
        title: "Estados de Cuentas",
        itemClickValue: 2,
        icon: "fas fa-pen-square",
      },
      {
        title: "Valoracion Fiscal de la Construccion",
        itemClickValue: 3,
        icon: "fas fa-address-card",
      },
    ],
  };
  const imprimirItem = {
    title: "Imprimir",
    icon: "fa fa-cog me-2",
    drop: [
      {
        title: "Contribuyentes por Serctor Catastral",
        itemClickValue: 10,
        icon: "fas fa-users-cog fa-fw me-1",
      },
      {
        title: "Contribuyentes por Monto del Avalúo",
        itemClickValue: 11,
        icon: "fas fa-users-cog fa-fw me-1",
      },

      {
        title: "Contribuyentes por Tipo de Construcción",
        itemClickValue: 12,
        icon: "fas fa-users-cog fa-fw me-1",
      },
      {
        title: "Contribuyentes por Monto de Deuda",
        itemClickValue: 13,
        icon: "fas fa-users-cog fa-fw me-1",
      },
      {
        title: " Tabla Valoracion Fiscal de Construccion",
        itemClickValue: 14,
        icon: "fas fa-users-cog fa-fw me-1",
      },
    ],
  };
  const configuracionItem = {
    title: "configuracion",
    icon: "fa fa-cog me-2",
    drop: [
      {
        title: "Configuración del Módulo",
        itemClickValue: 15,
        icon: "fas fa-users-cog fa-fw me-1",
      },
      {
        title: "usuarios",
        itemClickValue: 4,
        icon: "fas fa-users-cog fa-fw me-1",
      },
    ],
  };

  const PorDefecto = () => {
    const azulProfundo = "#003a70";
    const azulVibrante = "#007bff";

    return (
      <section
        className="col-12 m-0 p-0"
        style={{ height: "90dvh", overflow: "hidden" }}
      >
        <style>{`
            @keyframes float {
              0% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
              50% { transform: translateY(-20px) translateX(10px); opacity: 1; }
              100% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
            }
            .tech-dot {
              position: absolute;
              background: white;
              border-radius: 50%;
              animation: float 6s infinite ease-in-out;
            }
          `}</style>

        <div
          className="col-md-12 row mx-auto px-0"
          style={{ minHeight: "100%" }}
        >
          <div
            className="col-md-6 d-flex justify-content-center align-items-center"
            style={{
              position: "relative",
              left: "-50px",
              borderBottomRightRadius: "30%",
              height: "90dvh",
              backgroundColor: azulProfundo,
              overflow: "hidden",
              boxShadow: "10px 0 30px rgba(0,0,0,0.2)",
            }}
          >
            {/* 1. FONDO MESH GRADIENT (Profundidad) */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: `
                  radial-gradient(circle at 20% 30%, ${azulVibrante} 0%, transparent 50%),
                  radial-gradient(circle at 80% 70%, #00d4ff 0%, transparent 50%),
                  ${azulProfundo}
                `,
              }}
            />

            {/* 2. REJILLA TECNOLÓGICA (Grid lines) */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                backgroundImage: `linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), 
                                  linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)`,
                backgroundSize: "50px 50px",
              }}
            />

            {/* 3. PUNTOS ANIMADOS (Partículas) */}
            <div
              className="tech-dot"
              style={{
                width: "6px",
                height: "6px",
                top: "20%",
                left: "15%",
                animationDelay: "0s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "4px",
                height: "4px",
                top: "60%",
                left: "25%",
                animationDelay: "1s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "8px",
                height: "8px",
                top: "40%",
                left: "80%",
                animationDelay: "2s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "3px",
                height: "3px",
                top: "80%",
                left: "60%",
                animationDelay: "1.5s",
              }}
            />

            {/* 4. RÁFAGAS DE LUZ DIAGONALES */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 20%, rgba(255,255,255,0.05) 50%, transparent 100%)",
                transform: "skewX(-20deg)",
              }}
            />

            {/* LOGO CON GLOW */}
            <div
              style={{ position: "relative", zIndex: 10, textAlign: "center" }}
            >
              <img
                style={{
                  filter: "drop-shadow(0px 0px 30px rgba(255,255,255,0.3))",
                  maxWidth: "100%",
                  transition: "transform 0.3s ease",
                }}
                className="img-fluid"
                src={imgPresupuesto}
                alt="Logo SIAP"
              />
            </div>
          </div>

          {/* LADO DERECHO (Alcaldía) */}
          <div className="col-md-6 d-flex justify-content-center align-items-center">
            <img
              className="img-fluid px-5"
              src={op.imagenes + "/imagen?img=" + op.logohacienda}
              alt="Logo Alcaldía"
              style={{ maxWidth: "85%" }}
            />
          </div>
        </div>
      </section>
    );
  };

  const vista = {
    0: <DasboardInmueble />,
    1: (
      <TablaInmueble
        menu={() => {
          (setTabla(0), menuclick());
        }}
      />
    ),
    2: (
      <TablaEstadoCuentaInmueble
        menu={() => {
          (setTabla(0), menuclick());
        }}
      />
    ),
    3: (
      <TablaValorInmueble
        menu={() => {
          (setTabla(0), menuclick());
        }}
      />
    ),
    4: (
      <TablaUsuarioInmueble
        menu={() => {
          (setTabla(0), menuclick());
        }}
      />
    ),
    5: (
      <ImpSectorInmueblesUrbanos
        show={show}
        onHideCancela={() => {
          setShow(false);
          setTabla(0);
        }}
        titulo1={titulo1}
        titulo2={titulo2}
        tiporep={tipoRep}
      />
    ),
    15: (
      <ModalConfiguracionInmuebles
        show={show}
        configu={configuracion}
        onHideCancela={() => {
          setShow(false);
          setTabla(0);
        }}
        render={configInmueble}
      />
    ),
  };

  useEffect(() => {
    if (tabla === 10) {
      if (accusrepsectcat.toString() === "1") {
        setTitulo1("Impresión General de Contribuyentes por Sector");
        setTitulo2("Listado General de Contribuyentes por Sector");
        setTipoRep("1");
        setTabla(5);
      } else {
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo",
          titulo: "Alerta.",
        });
      }
    } else if (tabla === 11) {
      if (accusrepmontaval.toString() === "1") {
        setTitulo1("Listado Contribuyentes por Monto de Avalúo");
        setTitulo2("Listado Contribuyentes por Monto de Avalúo");
        setTipoRep("2");

        setTabla(5);
      } else {
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo",
          titulo: "Alerta.",
        });
      }
    } else if (tabla === 12) {
      if (accusreptipconstruc.toString() === "1") {
        setTitulo1("Listado Contribuyentes por Tipo de Construcción");
        setTitulo2("Listado Contribuyentes por Tipo de Construcción");
        setTipoRep("3");

        setTabla(5);
      } else {
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo",
          titulo: "Alerta.",
        });
      }
    } else if (tabla === 13) {
      if (accusrepmontdeud.toString() === "1") {
        setTitulo1("Tabla Valoracion Fiscal de Construcción");
        setTitulo2("Listado General de Contribuyentes por Fecha");
        setTipoRep("3");

        setTabla(5);
      } else {
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo",
          titulo: "Alerta.",
        });
      }
    } else if (tabla === 14) {
      if (accusrepvalorconstruc === "1") {
        let reporte = "Tabl_ValFis_Constr";
        window.open(
          op.reportes + "/inmueblesurbanos?" + "reporte=" + reporte,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
        );
      } else {
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este reporte",
          titulo: "Alerta.",
        });
      }
      setTabla(0);
    }
  }, [tabla]);

  const menu = user && (
    <div>
      <Menu fechaSistema={fechaSistema} op={op} show={() => setTabla(0)}>
        <Item item={actualizacionItem} setTabla={setTabla} setShow={setShow} />
        <Item item={imprimirItem} setTabla={setTabla} setShow={setShow} />
        <Item item={configuracionItem} setTabla={setTabla} setShow={setShow} />

        <a
          href="/haciendaMunicipal"
          className="list-group-item list-group-item-action bg-transparent text-danger fw-bold"
        >
          <i className="fas fa-power-off me-2" />
          Salir
        </a>
      </Menu>
      <section
        className="col-12 m-0 p-0 d-flex align-items-center justify-content-center"
        style={{ height: "100dvh" }}
      >
        {vista[tabla]}
      </section>

      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
    </div>
  );
  return menu;
}
export default MenuPrincipalInmueble;
